// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__TR9dQ","clickable":"styles_clickable__22bW7","disabled":"styles_disabled__22vKx"};